const HeroArgument = ($) => {
  const buttons = $(".wp-block-seven-shapes-hero-argument");
  
  buttons.on("click", (e) => {
    const btn = $(e.currentTarget);
    const imgSrc = btn.data("src");
    const imgSrcset = btn.data("srcset");
    const ImageHero = btn.parents(".wp-block-seven-shapes-section").find(".wp-block-seven-shapes-section__img img")
    const SourceHero = btn.parents(".wp-block-seven-shapes-section").find(".wp-block-seven-shapes-section__img source")

    if (ImageHero.length) {
      $(ImageHero).attr("src", imgSrc);
      $(SourceHero).attr("srcset", imgSrcset);
    }
  })
}

export default HeroArgument;